import CardHeader from "@material-ui/core/CardHeader";
import React from "react";

import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    title:{
        fontWeight: '500',
        letterSpacing: '-0.48px',
    },
    subheader: {
        fontSize: '1rem',
        lineHeight: '30px',
        letterSpacing: '-0.32px',
    },
    contentHeader:{
      paddingLeft: 0,
      paddingTop: 0,
      width: '100%',
    },
    contentContainer:{
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
      }
    }
  }));

const CardHead = (props) => {
  const classes = useStyles();
  const {title, subheader} = props;
  return (
      <CardHeader className={classes.contentHeader} classes={{title: classes.title, subheader: classes.subheader}} title={title} subheader={subheader} />
  );
};

export default CardHead;
